export default [
    'Imaging Facility (X-Ray)',
    'Pap Smear',
    'Electrocardiogram (ECG)',
    'Audiometry',
    'Pre-Employment Screening',
    'Nebuliser',
    'Ultrasound Scan',
    'Typhoid',
    'Full Medical Check Up',
    'HIV',
    'Full Blood Count',
    'Serology',
    'Blood Biochemistry Test',
    'Urine FEME'
];
